import { render } from "./SamplingPointDetail.view.vue?vue&type=template&id=790d1009&scoped=true&ts=true"
import script from "./SamplingPointDetail.view.vue?vue&type=script&lang=ts"
export * from "./SamplingPointDetail.view.vue?vue&type=script&lang=ts"

import "./SamplingPointDetail.view.vue?vue&type=style&index=0&id=790d1009&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790d1009"]])

export default __exports__